import { Grid } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';

export const ProfileRoot = () => (
  <Grid gridTemplateRows="128px 1fr" h="100%" w="100%">
    <Outlet />
  </Grid>
);
